import { render, staticRenderFns } from "./ParticipacaoTotalJurosAbsoluto.vue?vue&type=template&id=f432ba66&scoped=true&"
import script from "./ParticipacaoTotalJurosAbsoluto.vue?vue&type=script&lang=js&"
export * from "./ParticipacaoTotalJurosAbsoluto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f432ba66",
  null
  
)

export default component.exports